import TextMessage from "../text-message/text-message";
import QuickReplies from "../quick-replies";

// Legacy BUTTON_TEXT: { text, options: [{ btnText, fn }] }.
export default function ButtonOption(props) {
  const { message = {}, metadata, onCitationClick, chatBotSetting, disabled, senderType } = props;
  const buttons = (message?.options || []).map(option => ({ title: option.btnText, fn: option.fn }));

  return (
    <div className="w-full min-w-0">
      {message.text && (
        <TextMessage message={message.text} senderType={senderType} metadata={metadata} onCitationClick={onCitationClick} />
      )}
      <QuickReplies buttons={buttons} chatBotSetting={chatBotSetting} disabled={disabled} onSelect={button => button.fn?.()} />
    </div>
  );
}
